import React from 'react';
import HoverActionHeader from '@/components/HoverActionHeader';

const UserFieldHeader = ({ value, icon }) => (
  <HoverActionHeader value={value} icon={icon} className="aridhia-user-list-header" />
);

export default UserFieldHeader;
